// WebBridge: a plain browser (e.g. a tablet opening the dev server). Camera scanning works;
// a browser cannot open a raw TCP socket, so printing reports `unsupported`. The app pairs it
// with MockBridge printing (`combineBridges`) so the flow can still be exercised. A LAN relay
// may be added later.

import { createCameraScanner } from './camera.js';
import { createPrinter } from './printer.js';
import { ReprintQueue } from './reprint-queue.js';
import type { Device, DeviceBridge, Printer, Scanner } from './types.js';

export class WebBridge implements DeviceBridge {
  readonly kind = 'web' as const;
  readonly reprints = new ReprintQueue();
  readonly scanner: Scanner = createCameraScanner();
  readonly printer: Printer = createPrinter({
    queue: this.reprints,
    transport: {
      kind: 'none',
      send: async () => ({
        ok: false,
        reason: 'unsupported',
        message: 'A web browser cannot print labels. Use the station app, or the mock printer.',
      }),
      probe: async () => ({ state: 'unsupported' }),
    },
  });

  async discover(): Promise<Device[]> {
    return [];
  }
}

/** Takes printing (and its reprint list) from one bridge and scanning from another. */
export function combineBridges(parts: {
  printing: DeviceBridge;
  scanning: DeviceBridge;
}): DeviceBridge {
  return {
    kind: parts.scanning.kind,
    printer: parts.printing.printer,
    scanner: parts.scanning.scanner,
    reprints: parts.printing.reprints,
    discover: () => parts.printing.discover(),
  };
}
